// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#pane-urine .test-results .test-btn {\n  position: absolute;\n  right: 0;\n  width: 60%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0 15px;\n  z-index: 9;\n}", ""]);
// Exports
module.exports = exports;
